// initial state
import * as base from './base.js'
const baseName = '/admin/api/fund'

const obj = base.setBaseUrl('fund', baseName)
const a = Object.assign(obj)
export default a